<div class="flex flex-col items-center justify-center p-4 bg-white rounded-2xl border border-slate-200 shadow-sm text-center">
    <span class="text-xs uppercase tracking-wider font-semibold text-slate-400 mb-2">{{ label() }}</span>

    <div class="relative w-28 h-28 flex items-center justify-center">
        <!-- SVG Radial Ring -->
        <svg class="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
            <!-- Background track -->
            <circle cx="50" cy="50" r="40" stroke="#f1f5f9" stroke-width="8" fill="transparent" />

            <!-- Progress Arc -->
            <circle cx="50" cy="50" r="40"
                    stroke-width="8"
                    stroke-linecap="round"
                    fill="transparent"
                    stroke-dasharray="251.3"
                    [attr.stroke-dashoffset]="strokeDashoffset()"
                    [class.stroke-emerald-500]="statusCategory() === 'available'"
                    [class.stroke-amber-500]="statusCategory() === 'near_capacity'"
                    [class.stroke-rose-600]="statusCategory() === 'full' || statusCategory() === 'overflow'"
                    class="transition-all duration-500 ease-out" />
        </svg>

        <!-- Center Value -->
        <div class="absolute inset-0 flex flex-col items-center justify-center">
            <span class="text-2xl font-extrabold text-slate-900 leading-none">
                {{ value() }}
            </span>
            <span class="text-[11px] font-semibold text-slate-400 mt-0.5">
                / {{ max() }} {{ unit() }}
            </span>
        </div>
    </div>

    <!-- Status Badge -->
    <div class="mt-3">
        @if (statusCategory() === 'available') {
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700">
            Available ({{ percentage().toFixed(0) }}%)
        </span>
        } @else if (statusCategory() === 'near_capacity') {
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-50 text-amber-700">
            Near Full ({{ percentage().toFixed(0) }}%)
        </span>
        } @else if (statusCategory() === 'full') {
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-rose-50 text-rose-700">
            Full (100%)
        </span>
        } @else {
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-purple-50 text-purple-700">
            Overflow
        </span>
        }
    </div>
</div>
